import React from 'react'
import cn from 'classnames'
import { isLessonTile } from 'libs/utils/outcomes'
import { CourseMeta, OutcomeContent } from 'types/data'
import { useSubcategoryPageEvents } from '../../utils'
import { CourseContentTile } from './CourseContentTile'
import { InstructorInfo } from './InstructorInfo'
import { LessonContentTile } from './LessonContentTile'
import classes from './OutcomeTile.module.scss'

interface OutcomeTileProps {
  courseMeta: CourseMeta
  content: OutcomeContent
  isCarouselTile?: boolean
  isPrioritized?: boolean
  isHidden?: boolean
  outcomeName: string
  rowIndex?: number
  rowCount?: number
  colIndex: number
  colCount: number
}

export const OutcomeTile = ({
  courseMeta,
  content,
  isCarouselTile = false,
  isPrioritized = false,
  isHidden = false,
  outcomeName,
  rowIndex,
  rowCount,
  colIndex,
  colCount,
}: OutcomeTileProps) => {
  const { trackOutcomeTileClicked } = useSubcategoryPageEvents()

  const position = {
    rowIndex,
    rowCount,
    colIndex,
    colCount,
  }

  const location = isCarouselTile
    ? `outcome_carousel:${outcomeName}`
    : `outcome_list:${outcomeName}`

  return (
    <div
      className={cn({
        [classes.carouselTile]: isCarouselTile,
        'col-12 col-sm-6 col-lg-4 mc-px-2': !isCarouselTile,
        'd-none': isHidden,
      })}
    >
      {isLessonTile(content) ? (
        <LessonContentTile
          content={content}
          courseMeta={courseMeta}
          isPrioritized={isPrioritized}
          trackOnClick={() =>
            trackOutcomeTileClicked(
              'click_lesson',
              outcomeName,
              'lesson',
              courseMeta.courseSlug,
              location,
              position,
            )
          }
        />
      ) : (
        <CourseContentTile
          content={content}
          courseMeta={courseMeta}
          isPrioritized={isPrioritized}
          trackOnClick={() =>
            trackOutcomeTileClicked(
              'click_trailer',
              outcomeName,
              'class',
              courseMeta.courseSlug,
              location,
              position,
            )
          }
        />
      )}
      <InstructorInfo
        courseMeta={courseMeta}
        trackOnClick={() =>
          trackOutcomeTileClicked(
            'click_class',
            outcomeName,
            isLessonTile(content) ? 'lesson' : 'class',
            courseMeta.courseSlug,
            location,
            position,
          )
        }
      />
    </div>
  )
}
